module.exports = __webpack_public_path__ + "static/media/2 location street barber sidewalk urban architecture 1280x2276.37cc2466.webp";